import React from "react";
import CorporateAccountForm from "../../../../Components/corporate/CorporateAccountForm";
import { Failed, Succeeded } from "../../../../Components/Form";
import { ButtonPrimary } from "../../../../Components/Button";
import CustomFieldContainer from "../custom-fields/CustomFieldContainer";

let CorporateAccountOverview = ({
  corporateAccount,
  onSubmit,
  success,
  error,
  companies,
  onAddNewCategory,
  toggleActiveAccount,
  corporateAccountUsers,
  bookingDesks,
  slug,
  corporatePermissions,
  isRolePlatformAdmin,
}) => {
  return (
    <div className={"bg-white p-5 mt-10"}>
      <div className="flex justify-between">
        <h1
          className={
            "mb-4 md:mt-4 md:mb-6 md:flex md:flex-row md:justify-between md:items-center"
          }
        >
          Overview
        </h1>
        <div className="mb-4 md:mt-4 md:mb-6 md:flex md:flex-row md:justify-between md:items-center">
          {corporateAccount.is_active === 0 && (
            <ButtonPrimary
              classes={"mr-3"}
              onClick={() => toggleActiveAccount(true)}
            >
              <i className="fas fa-check-circle mr-3" /> Activate Account
            </ButtonPrimary>
          )}
          {corporateAccount.is_active === 1 && (
            <ButtonPrimary
              classes={"bg-dark-red"}
              onClick={() => toggleActiveAccount(false)}
            >
              <i className="fas fa-trash mr-3" /> Deactivate Account
            </ButtonPrimary>
          )}
        </div>
      </div>
      <CorporateAccountForm
        type={"edit"}
        slug={slug}
        corporateAccount={corporateAccount}
        bookingDesks={bookingDesks}
        corporateAccountUsers={corporateAccountUsers}
        companies={companies}
        onSubmit={onSubmit}
        toggleActiveAccount={toggleActiveAccount}
        buttonText={"Save Changes"}
        corporatePermissions={corporatePermissions}
      />
      {!error && success && <Succeeded leftAlign />}
      {!success && error && <Failed leftAlign />}
      {isRolePlatformAdmin ? (
        <CustomFieldContainer
          corporateAccount={corporateAccount}
          onAddNewCategory={onAddNewCategory}
        />
      ) : null}
    </div>
  );
};

export default CorporateAccountOverview;
